module.exports = __webpack_public_path__ + "img/JBI_PACES-freeproduct_img@2x.8477901a.png";